import React from 'react';
import Button from '../Button';
import { ContainerStyled as Container, IconStyled as IconContainer, ButtonContainerStyled as ButtonContainer, TitleStyled as Title, SubtitleStyled as Subtitle, ChevronStyled as ChevronIcon, TextStyled as Text } from './styles/ActionRowStyled';
var ActionRow = function ActionRow(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$showButton = _ref.showButton,
    showButton = _ref$showButton === void 0 ? false : _ref$showButton,
    buttonText = _ref.buttonText,
    handleClick = _ref.handleClick,
    icon = _ref.icon;
  return React.createElement(Container, {
    showButton: showButton,
    onClick: function onClick() {
      return !showButton && handleClick();
    }
  }, React.createElement(IconContainer, null, icon), React.createElement(Text, null, React.createElement(Title, null, title), React.createElement(Subtitle, null, subtitle)), showButton ? React.createElement(ButtonContainer, {
    showButton: showButton
  }, React.createElement(Button, {
    variant: "outlined",
    color: "corporate",
    onClick: handleClick
  }, buttonText)) : React.createElement(ButtonContainer, null, React.createElement(ChevronIcon, null)));
};
export default ActionRow;